<script lang="ts">
    import CardSimple from '../../card/card-simple.svelte';

    //exports
    export let currency;
    export let balance;
</script>

<CardSimple title="Balance">
    <div class="max-w-xs truncate px-4 py-3.5">{currency} {balance}</div>
</CardSimple>
